import React from "react";
import CommonBankLogo from "../../../../CommonBankLogo";

/**
 * ------------------------------------------------------------------
 * AccountSection Component
 * ------------------------------------------------------------------
 * @param {Object} props
 *
 * @param {string} props.bgColor
 * Background color of the section container.
 *
 * @param {string} props.title
 * Main heading displayed at the top.
 *
 * @param {string} props.subtitle
 * Secondary text below the main title.
 *
 * @param {string} props.bottomTitle
 * Primary text shown in the bottom row.
 *
 * @param {string} props.bottomSubtitle
 * Secondary text shown below bottom title.
 *
 * @param {string} [props.ifsc]
 * IFSC code used to render the bank logo via CommonBankLogo.
 * If not provided, the logo section will not render.
 *
 * @param {string} [props.dividerColor]
 * Color of the horizontal divider separating top and bottom sections.
 *
 * @returns {JSX.Element}
 */

const AccountSection = ({
  bgColor,
  title,
  subtitle,
  bottomTitle,
  bottomSubtitle,
  ifsc,
  dividerColor,
}) => {
  return (
    <div
      className="rounded-border-radius-md"
      style={{ backgroundColor: bgColor }}
    >
      <div className="flex flex-col py-padding-sm px-padding-md">
        <div className="flex flex-col gap-gap-xs">
          <p className="text-font-sm text-text-primary text-left font-normal">
            {title}
          </p>
          <p className="text-text-secondary text-font-xs font-normal text-left">
            {subtitle}
          </p>
        </div>
        <hr
          className="my-margin-sm border"
          style={{
            borderColor: dividerColor,
          }}
        />
        <div className="flex justify-between items-center">
          <div className="flex flex-col gap-gap-xs">
            <p className="text-font-sm text-text-primary text-left font-normal">
              {bottomTitle}
            </p>
            <p className="text-text-secondary text-font-xs font-normal text-left">
              {bottomSubtitle}
            </p>
          </div>
          {ifsc && (
            <div className="flex flex-row gap-gap-sm items-center">
              <CommonBankLogo
                variant="big"
                ifsc={ifsc}
                type="pill"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccountSection;
